import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
  formatPrice,
} from "../../../store";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
} from "../../../utils/utils";
import { getCall } from "../../../api/post";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class RewardPoints extends Component {
  state = {
    isLoading: true,
    rewardPointsList: [],
    totalRewardPoints: 0,
    searchValue: "",
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
  };

  componentDidMount() {
    this.fetchRewardPoints();
  }

  fetchRewardPoints = (searchValue = "") => {
    const userDetails = loadUserDetailsFromLocalStorage();
    const agentId = userDetails && userDetails.id;
    if (!agentId) return;

    let apiUrl = `v2/agentrewards?where[agentId]=${agentId}`;
    if (searchValue) {
      apiUrl += `&search=${encodeURIComponent(searchValue)}`;
    }

    this.setState({ isLoading: true });

    getCall(apiUrl)
      .then((response) => {
        const rewards = response.data || [];
        const totalPoints = rewards.reduce((sum, item) => sum + (item.points || 0), 0);

        this.setState({
          rewardPointsList: rewards,
          totalRewardPoints: totalPoints,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          rewardPointsList: [],
          totalRewardPoints: 0,
          isLoading: false,
          showErrorMessageModal: true,
          errorMessage: "Failed to fetch reward points.",
        });
      });
  };

  handleSearch = () => {
    this.fetchRewardPoints(this.state.searchValue);
  };

  handleReset = () => {
    this.setState({ searchValue: "" }, () => {
      this.fetchRewardPoints();
    });
  };

  handleDownloadStatement = async () => {
    try {
      const userDetails = loadUserDetailsFromLocalStorage();
      if (!userDetails || !userDetails.apitoken) return;

      const SERVER_URL = `${process.env.SERVER_URL}/api/`;

      const apiUrl = `${SERVER_URL}v2/agentrewards/export-excel`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.apitoken}`,
          // Add other headers if needed
        }
      });
      if (!response.ok) throw new Error("Failed to download statement.");
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "rewards_points.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      this.loadErrorMessageAnimation("Failed to download statement.");
    }
  };

  renderRewardPointsTableTab = () => {
    const strDateAdded = getValueFromLanguageObject("str_date_added")
      ? getValueFromLanguageObject("str_date_added")
      : "Date Added";

    const strDescription = getValueFromLanguageObject("str_description")
      ? getValueFromLanguageObject("str_description")
      : "Description";

    const strPoints = getValueFromLanguageObject("str_points")
      ? getValueFromLanguageObject("str_points")
      : "Points";

    return (
      <thead>
        <tr className="table-head">
          <th scope="col" className="pb-1 pt-1">
            {strDateAdded}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strDescription}
          </th>
          <th scope="col" className="pb-1 pt-1">
            {strPoints}
          </th>
        </tr>
      </thead>
    );
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ showErrorMessageModal: true, errorMessage: message });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ showSuccessMessageModal: true, successMessage: message });
  };

  debouncedSearch = debounce((value) => {
    this.fetchRewardPoints(value);
  }, 500);

  render() {
    const {
      isLoading,
      totalRewardPoints,
      searchValue,
      rewardPointsList,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
    } = this.state;

    // Filter data based on search
    const filteredData = rewardPointsList.filter(item =>
      (item.description && item.description.toLowerCase().includes(searchValue.toLowerCase())) ||
      (typeof item.status === "string" && item.status.toLowerCase().includes(searchValue.toLowerCase()))
    );

    return (
      <>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" type="image/x-icon" href={process.env.PUBLIC_URL + `/assets/images/icon/favicon_razerewards.png`} />
          <title>
            {getValueFromLanguageObject("str_reward_points")
              ? getValueFromLanguageObject("str_reward_points")
              : "Reward Points"}
          </title>
          <meta
            name="description"
            content="Reward Points - Track your loyalty points and rewards"
          />
        </Helmet>

        <Breadcrumb
          title={
            getValueFromLanguageObject("str_reward_points")
              ? getValueFromLanguageObject("str_reward_points")
              : "Reward Points"
          }
        />

        <section className="cart-section section-b-space">
          <div className="container">
            {/* Total Points and Download Statement */}
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="total-points-display">
                  <h4 className="mb-0">
                    {getValueFromLanguageObject("str_your_total_reward_points") || "Your total reward points is"} : <span className="text-primary">{formatPrice(totalRewardPoints)}</span>
                  </h4>
                </div>
              </div>
              {/* <div className="col-md-6 text-right">
                <button 
                  className="btn btn-warning download-statement-btn"
                  onClick={this.handleDownloadStatement}
                >
                  <i className="fa fa-download mr-2" aria-hidden="true"></i>
                  {getValueFromLanguageObject("str_download_statement") || "Download Statement"}
                </button>
              </div> */}
            </div>

            {/* Search Section */}
            {/* <div className="row mb-4">
              <div className="col-md-6">
                <div className="search-section">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={getValueFromLanguageObject("str_search") || "Search"}
                      value={searchValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        this.setState({ searchValue: value });
                        this.debouncedSearch(value);
                      }}
                    />
                    <div className="input-group-append">
                      <button 
                        className="btn download-statement-btn" 
                        type="button"
                        onClick={this.handleSearch}
                      >
                        {getValueFromLanguageObject("str_search") || "Search"}
                      </button>
                      <button 
                        className="btn download-statement-btn ml-2" 
                        type="button"
                        onClick={this.handleReset}
                      >
                        {getValueFromLanguageObject("str_reset") || "Reset"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="collection-product-wrapper order-page-filter">
              <div className="product-top-filter">
                <div className="container-fluid p-0">
                  <div className="row">
                    <div className="col-12">
                      <div className="product-filter-content">
                        <div className="search-count">
                          <h5
                            style={{
                              color: getColorCodeBasedOnKey("text_showing_order_order"),
                            }}
                          >
                            {getValueFromLanguageObject("str_showing_reward_points")
                              ? getValueFromLanguageObject("str_showing_reward_points")
                              : "Showing Reward Points"}{" "}
                            {filteredData.length}{" "}
                            {getValueFromLanguageObject("str_result")
                              ? getValueFromLanguageObject("str_result")
                              : "Results"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Reward Points Table */}
            <div className="container-fluid px-4"> {/* Add px-4 for horizontal padding */}
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="card shadow-sm border-0" style={{ borderRadius: "14px", marginTop: 16 }}>
                    <div className="card-body p-4">
                      <h4 className="mb-4" style={{ fontWeight: 600, color: "#333" }}>
                        {getValueFromLanguageObject("str_reward_points") || "Reward Points"}
                      </h4>
                      {/* Filter Bar - Improved UI */}
                      <div className="d-flex align-items-center justify-content-between mb-4" style={{ gap: "16px" }}>
                        <div className="d-flex align-items-center" style={{ gap: "10px", flex: 1 }}>
                          <input
                            type="text"
                            className="form-control"
                            style={{
                              maxWidth: 320,
                              borderRadius: "6px",
                              border: "1px solid #d1d5db",
                              fontSize: "15px",
                              padding: "8px 12px",
                              boxShadow: "none"
                            }}
                            placeholder={getValueFromLanguageObject("str_search") || "Search"}
                            value={searchValue}
                            onChange={(e) => {
                              const value = e.target.value;
                              this.setState({ searchValue: value });
                              this.debouncedSearch(value);
                            }}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            style={{
                              minWidth: 90,
                              fontWeight: 500,
                              borderRadius: "6px",
                              height: "40px"
                            }}
                            onClick={this.handleReset}
                          >
                            Reset
                          </button>
                        </div>
                        <button
                          className="btn btn-warning d-flex align-items-center justify-content-center"
                          type="button"
                          style={{
                            minWidth: 190,
                            fontWeight: 600,
                            borderRadius: "6px",
                            height: "40px",
                            boxShadow: "none",
                            gap: "8px"
                          }}
                          onClick={this.handleDownloadStatement}
                        >
                          <i className="fa fa-download" aria-hidden="true" style={{ fontSize: "18px" }}></i>
                          Download Statement
                        </button>
                      </div>
                      {/* Table */}
                      <div style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #f0f0f0" }}>
                        <table
                          className="table table-hover mb-0"
                          style={{
                            width: "100%",
                            background: "#fff",
                            fontSize: "15px",
                            tableLayout: "auto"
                          }}
                        >
                          <thead className="thead-light" style={{ background: "#f5f7fa" }}>
                            <tr>
                              <th style={{ width: "25%", fontWeight: 500, fontSize: 15, textAlign: "left", border: "none" }}>
                                {getValueFromLanguageObject("str_date_added") || "Date"}
                              </th>
                              <th style={{ width: "55%", fontWeight: 500, fontSize: 15, textAlign: "left", border: "none" }}>
                                {getValueFromLanguageObject("str_description") || "Description"}
                              </th>
                              <th style={{ width: "20%", fontWeight: 500, fontSize: 15, textAlign: "center", border: "none" }}>
                                {getValueFromLanguageObject("str_points") || "Points"}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData.length > 0 ? (
                              filteredData.map((item) => (
                                <tr key={item.id} style={{ background: "#fff" }}>
                                  <td style={{ verticalAlign: "middle", textAlign: "left", border: "none" }}>
                                    {item.created ? new Date(item.created).toLocaleDateString() : ""}
                                  </td>
                                  <td style={{ verticalAlign: "middle", textAlign: "left", border: "none" }}>
                                    <div style={{
                                      fontSize: "15px",
                                      color: "#222",
                                      fontWeight: 400,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}>
                                      <i className="fa fa-star" style={{ color: "#FF6A00", fontSize: "14px" }} />
                                      <span>{item.description}</span>
                                    </div>
                                  </td>
                                  <td style={{ verticalAlign: "middle", textAlign: "center", border: "none" }}>
                                    <span className={item.points >= 0 ? "text-success" : "text-danger"} style={{ fontWeight: 500, fontSize: "15px" }}>
                                      {item.points >= 0 ? "+" : ""}{formatPrice(item.points)}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center py-5" style={{ background: "#fff", border: "none" }}>
                                  <div className="empty-state">
                                    <div className="empty-state-icon">
                                      <div className="circle-icon">
                                        <i className="fa fa-star" style={{ color: '#ff6b6b', fontSize: '2rem' }}></i>
                                      </div>
                                    </div>
                                    <div className="empty-state-text">
                                      <p>{getValueFromLanguageObject("str_no_reward_points_found") || "No reward points found matching your search!"}</p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {showErrorMessageModal && (
          <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{getValueFromLanguageObject("str_error") || "Error"}</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.setState({ showErrorMessageModal: false })}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>{errorMessage}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {showSuccessMessageModal && (
          <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{getValueFromLanguageObject("str_success") || "Success"}</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.setState({ showSuccessMessageModal: false })}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>{successMessage}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {isLoading && (
          <div className="loading-wrapper">
            <div className="loading-spinner"></div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // Add any state mappings if needed
});

export default connect(mapStateToProps, {})(withRouter(RewardPoints));